import React from "react";
import { SelectedIcon } from "../../Icons";
import { concatStringFromClassesArrayList } from "../../Utils";

export interface BreadcrumbItem {
  itemClasses?: string;
  linkClasses?: string;
  id?: string;
  url: string;
  onClick?: (...args: any[]) => void;
  text: string;
  attributes?: { [key: string]: string };
  dataTestId?: string;
}

export interface Props {
  classes?: string;
  ariaLabel?: string;
  id?: string;
  dataTestId: string;
  itemsList: BreadcrumbItem[];
}

export const Breadcrumb = (props: Props) => {
  const classList = {
    defaultClass: "ons-breadcrumbs",
    optionalClasses: [props.classes ? props.classes : null],
  };
  const className = concatStringFromClassesArrayList(classList);

  return (
    <nav
      className={className}
      data-testid={props.dataTestId}
      id={props.id || "breadcrumb-id"}
      aria-label={props.id || "Breadcrumbs"}
    >
      <ol className="ons-breadcrumbs__items ons-u-fs-s">
        {props.itemsList.map((item, index) => (
          <li
            key={index}
            className={`ons-breadcrumbs__item ${
              item.itemClasses ? item.itemClasses : ""
            }`}
            {...(item.id ? { id: item.id } : {})}
            {...(item.dataTestId ? { "data-testid": item.dataTestId } : {})}
          >
            <a
              className={`ons-breadcrumbs__link ${
                item.linkClasses ? item.linkClasses : ""
              }`}
              href={item.url}
              onClick={(e) =>
                typeof item.onClick === "function" && item.onClick(e)
              }
              {...(item.id ? { id: `${item.id}-link` } : {})}
              {...(item.dataTestId
                ? { "data-testid": `${item.dataTestId}-link-${index}` }
                : {})}
              {...(item.attributes
                ? Object.entries(item.attributes)
                    .map(([attribute, value]) => ({
                      [attribute]: value,
                    }))
                    .reduce(
                      (acc, attribute) => ({
                        ...acc,
                        ...attribute,
                      }),
                      {},
                    )
                : {})}
            >
              {item.text}
            </a>
            <SelectedIcon iconType="ArrowIcon" />
          </li>
        ))}
      </ol>
    </nav>
  );
};
